import React from 'react';

import { Skeleton } from '@/components/Skeleton';
import { SKELETON_COLOR_SCHEMES } from '@/components/Skeleton/constants';

const ItineraryItem = ({ arrival = false }: { arrival?: boolean }) => (
  <li className="ItineraryListNew__item">
    <div className="ItineraryListNew__daySection">
      <Skeleton inline width="1.5rem" />
    </div>
    <div className="ItineraryListNew__portsSection">
      <div className="ItineraryListNew__icon">
        <Skeleton height="50px" width="50px" />
      </div>
      <div className="ItineraryListNew__body">
        <div className="ItineraryListNew__itemParagraph">
          <span className="ItineraryListNew__location">
            <Skeleton inline width="80%" />
          </span>
          <div className="ItineraryListNew__description">
            <Skeleton inline width="80%" />
          </div>
          <div className="ItineraryListNew__allAboardSection">
            <Skeleton inline width="80%" />
          </div>

          {arrival && (
            <p className="ItineraryListNew__arrivalPortMessage">
              <Skeleton inline width="80%" />
            </p>
          )}
        </div>
      </div>
    </div>
  </li>
);

const PreCheckOutSummaryModuleSkeleton = () => {
  return (
    <>
      <div className="PreCheckOutSummaryModule PreCheckOutSummaryModuleSkeleton">
        <div className="PreCheckOutSummaryModuleMain">
          <div className="itineraryDetails">
            <div className="itineraryHeading">
              <Skeleton inline width={60} />
              <span className="shipName">
                <Skeleton inline width={60} />
              </span>
            </div>
            <h2 className="itineraryName">
              <Skeleton inline width="100%" />
            </h2>
            <div className="itineraryDate">
              <span>
                <Skeleton inline width={60} />
              </span>
              <span>
                <Skeleton inline width={60} />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="PreCheckOutSummaryModule__PortsOfCall">
        <div className="FullCruisePortsOfCall">
          <div className="FullCruiseImage">
            <Skeleton height="385px" {...SKELETON_COLOR_SCHEMES['gray-216-gray-100']} width="100%" />
          </div>
          <div className="portsOfCalls">
            <ul className="ItineraryListNew ItineraryListNewSkeleton">
              <li className="ItineraryListNew__header">
                <div className="ItineraryListNew__dayHeader">
                  <Skeleton inline width="50px" />
                </div>
                <div className="ItineraryListNew__portHeader">
                  <Skeleton inline width="50px" />
                </div>
              </li>
              <ItineraryItem />
              <ItineraryItem />
              <ItineraryItem />
              <ItineraryItem />
              <ItineraryItem />
              <ItineraryItem arrival />
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreCheckOutSummaryModuleSkeleton;
